class UniqueKey {
    static MAX = 10000;
    static generateKey(prefix: string) {
        return `${prefix}_${Math.floor(
            Math.random() * UniqueKey.MAX
        )}_${new Date().getTime()}`;
    }

    static generateId(
        options: { length?: number; prefix?: string | number } = {
            length: 36,
            prefix: "",
        }
    ) {
        return (
            (options.prefix ? `${options.prefix}_` : "") +
            "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
                .slice(0, options.length)
                .replace(/[xy]/g, function (char) {
                    let randomizer = (Math.random() * 16) | 0;
                    let value =
                        char === "x" ? randomizer : (randomizer & 0x3) | 0x8;
                    return value.toString(16);
                })
        );
    }
}

export default UniqueKey;
